const formScript = `
(function () {
  if (window.__formSubmitInit__) return;
  window.__formSubmitInit__ = true;

  const BOUND_FORMS = new WeakSet();

  function getWebsiteId(formEl) {
    const fromDataAttr = formEl.dataset.websiteId;
    if (fromDataAttr && String(fromDataAttr).trim()) return String(fromDataAttr).trim();

    const hidden = formEl.querySelector('input[name="website_id"]');
    const fromHidden = hidden && hidden.value ? String(hidden.value).trim() : '';
    if (fromHidden) return fromHidden;

    return '';
  }
  
  function buildPlaceholderPayload(form) {
    const fields = form.querySelectorAll('input, textarea, select');
    const out = {};

    fields.forEach(field => {
      if (
        field.type === 'submit' ||
        field.type === 'button' ||
        field.type === 'reset'
      ) {
        return;
      }
      
      const nameLower = (field.getAttribute('name') || '').toLowerCase();
      if (nameLower === 'website_id' || nameLower === 'websiteId') return;
    

      const key = (field.placeholder || field.name || '').trim();
      if (!key) return;
      let value;
      if (field.type === 'checkbox') {
        const sameNamed = field.name
          ? form.querySelectorAll(\`[name="\${field.name}"]\`)
          : [];

        if (sameNamed.length > 1) {
          if (!Array.isArray(out[key])) out[key] = [];
          if (field.checked) out[key].push(field.value || 'on');

          // if after pushing we still have nothing (nobody checked yet), don't keep empty array
          if (Array.isArray(out[key]) && out[key].length === 0) {
            delete out[key];
          }

          return;
        } else {
          value = field.checked ? (field.value || 'on') : '';
        }
      } else if (field.type === 'radio') {
        if (!field.checked) return;
        value = field.value;
      } else {
        value = field.value;
      }

      // skip empty values
      if (
        value === '' ||
        value === null ||
        value === undefined
      ) {
        return;
      }

      if (key in out) {
        if (Array.isArray(out[key])) {
          out[key].push(value);
        } else {
          out[key] = [out[key], value];
        }
      } else {
        out[key] = value;
      }
    });

    
    Object.keys(out).forEach(k => {
      if (Array.isArray(out[k]) && out[k].length === 0) {
        delete out[k];
      }
    });

    return out;
  }

  async function onSubmit(e) {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.dataset.submitting === '1') return;
    form.dataset.submitting = '1';

    const submits = form.querySelectorAll('[type="submit"], button:not([type]), button[type="submit"]');
    submits.forEach(btn => (btn.disabled = true));

    try {
      const websiteId = getWebsiteId(form);
      if (!websiteId) { alert('Missing website id.'); return; }

      const payload = { payload: buildPlaceholderPayload(form) };

      const url = 'https://pmqekpgdga.execute-api.us-east-1.amazonaws.com/public/v1/websites/'
        + encodeURIComponent(websiteId)
        + '/form-submissions';

      const res = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const json = await res.json().catch(() => null);

      if (!res.ok) {
        console.error('Form submission failed:', res.status, json || res.statusText);
        alert('The website needs to be published to be able to submit the form');
        return;
      }

      const wrapper = form.closest('.form.container') || form.parentElement;
      const successWrap = document.createElement('div');
      successWrap.className = 'form container';
      successWrap.innerHTML = '<div class="form-success" role="status" aria-live="polite" tabindex="-1"><h3>' + json.message + '</h3></div>';

      wrapper.replaceWith(successWrap);
      successWrap.querySelector('.form-success')?.focus();
      return;
    } catch (err) {
      console.error('Error submitting the form:', err);
      alert('The website needs to be published to be able to submit the form');
    } finally {
      if (form.isConnected) {
        submits.forEach(btn => (btn.disabled = false));
        delete form.dataset.submitting;
      }
    }
  }

  function setupSubmitListener(form) {
    if (!form || BOUND_FORMS.has(form)) return;
    BOUND_FORMS.add(form);
    form.addEventListener('submit', onSubmit);
  }

  const bindAll = () => document.querySelectorAll('form').forEach(setupSubmitListener);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }

  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      m.addedNodes.forEach(n => {
        if (n.nodeType !== 1) return;
        if (n.matches?.('form')) setupSubmitListener(n);
        n.querySelectorAll?.('form').forEach(setupSubmitListener);
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
`;

export const generateFormScript = () => {
  return formScript;
};
